@if (!indicatorStore.asArray().length || !layerStore.asArray().length) {
  <app-alert
    header="Es können noch keine Daten importiert werden"
    [canToggle]="false">
    Bevor Sie Daten importieren können, müssen Sie zuerst Indikatoren und Jahre
    anlegen, da die Daten Jahren und Indikatoren zugeordnet werden müssen.
  </app-alert>
} @else {
  <header *ngIf="!importValidationResult">
    <app-header
      icon="fas fa-location-arrow"
      text="Auswahl treffen"></app-header>
    <div class="p-3 p-card surface-ground">
      <div class="flex gap-3 align-items-center">
        <ng-container *ngIf="typeSelectItems">
          <app-type-dropdown
            [globalSelector]="true"
            mode="all"
            [(selection)]="selectedType"></app-type-dropdown>
        </ng-container>
        <ng-container *ngIf="layerStore.initialized()">
          <app-layer-dropdown
            [displayNewYearOption]="true"
            [disabled]="multipleYears"
            [(selection)]="selectedLayer"
            [globalSelector]="true"></app-layer-dropdown>
        </ng-container>
        <div>
          <p-checkbox
            [binary]="true"
            [(ngModel)]="multipleYears"
            label="Mehrere Jahre auswählen" />
          <div class="text-xs text-color-secondary pt-1">
            Importieren oder exportieren Sie Daten für mehrere Jahre
            gleichzeitig.
          </div>
        </div>
        <div class="ml-auto">
          <p-button
            [disabled]="multipleYears"
            styleClass="p-button-excel"
            [rounded]="true"
            icon="fas fa-file-excel"
            (click)="downloadTemplate()"
            label="Vorlage herunterladen"></p-button>
        </div>
      </div>
      @if (multipleYears) {
        <p-divider />
        <div
          class="text-sm flex gap-2 text-color-secondary align-items-baseline">
          <i class="fas fa-info-circle"></i>
          <i
            >Wenn Sie mehrere Jahre exportieren wollen, können Sie dies nur für
            ausgewählte Indikatoren tun. Eine allgemeine Vorlage steht nicht zur
            Verfügung.</i
          >
        </div>
      }
    </div>
  </header>
  <div class="grid">
    <div
      [ngClass]="{
        'col-6': !importValidationResult,
        'col-12': importValidationResult,
      }">
      <app-header
        icon="fas fa-cloud-upload"
        text="Import"
        sub="Laden Sie Ihre Daten als Excel-Datei hoch."></app-header>
      @if (canImport()) {
        @if (!importValidationResult) {
          <div
            class="p-3 p-card surface-ground flex gap-4 align-content-center">
            <div>
              <p-fileUpload
                mode="basic"
                chooseLabel="Datei hochladen"
                chooseIcon="pi pi-upload"
                name="uploadFile"
                [url]="indicatorDataService.getImportUrl(multipleYears)"
                [auto]="true"
                accept=".xlsx"
                maxFileSize="10000000"
                (onBeforeUpload)="isUploading = true"
                (onUpload)="onUpload($event)"
                (onError)="onUploadError()" />
            </div>
            <div
              *ngIf="true"
              class="flex align-items-center gap-2 text-color-secondary">
              <p-progressSpinner
                *ngIf="isUploading"
                styleClass="w-2rem h-2rem"
                strokeWidth="4"
                fill="var(--surface-ground)"
                animationDuration=".5s" />
              <span>Datei wird verarbeitet...</span>
            </div>
          </div>
          <app-alert
            severity="info"
            [canToggle]="false"
            header="Daten importieren">
            @if (multipleYears) {
              <p>
                <strong
                  >Beachten Sie, dass Sie für den Import mehrerer Jahre eine
                  abweichendes Excel-Format nutzen müssen.</strong
                >
              </p>
              <p>
                Nutzen Sie einfach den Export der betreffenden Indikatoren um
                die passende Vorlage zu erhalten.
              </p>
            } @else {
              <p>Die Datei muss einem bestimmten Schema entsprechen.</p>
              <p>
                Laden Sie die passende <b>Vorlage</b> herunter, um das richtige
                Format zu verwenden.
              </p>
            }
          </app-alert>
        } @else if (importValidationResult) {
          <h3>Zusammenfassung</h3>
          @if (
            importValidationResults && validationYears && validationYears.length
          ) {
            @if (missingYears.length) {
              <app-alert
                header="Fehlende Jahre"
                severity="warning"
                [canToggle]="false">
                Folgende Jahre gibt es <u>nicht</u> im System und werden beim
                Import ignoriert:
                <ul>
                  @for (year of missingYears; track $index) {
                    <li>{{ year }}</li>
                  }
                </ul>
              </app-alert>
            }
            <p-tabView
              styleClass="no-spacing--x"
              (onChange)="setYearToShow($event)">
              <p-tabPanel *ngFor="let year of validationYears" [header]="year">
                <app-import-validation-result-data
                  (itemsToShow)="setItemsToShow($event)"
                  [importValidationResult]="
                    importValidationResults[year]
                  "></app-import-validation-result-data>
              </p-tabPanel>
            </p-tabView>
          } @else {
            <app-import-validation-result-data
              (itemsToShow)="setItemsToShow($event)"
              [importValidationResult]="
                importValidationResult
              "></app-import-validation-result-data>
          }

          <div
            class="p-3 pt-1"
            [appAlertStyle]="
              importValidationResult.preview.error.length > 0
                ? 'warning'
                : 'info'
            ">
            <h3 class="flex align-items-center gap-2">
              <i class="fas fa-info-circle"></i> Die Excel-Datei wurde
              erfolgreich geprüft!
            </h3>
            @if (importValidationResult.preview.error.length > 0) {
              <p>
                <strong>Text oder Symbole erkannt:</strong> Diese werden beim
                Import als „k. A.“ (keine Angabe) gespeichert.
              </p>
              <p>
                <a
                  class="underline cursor-pointer"
                  (click)="setItemsToShow('error')"
                  >Fehlerdetails ansehen.</a
                >
              </p>
            } @else if (
              importValidationResult.preview.success.length === 0 &&
              importValidationResult.preview.info.length === 0 &&
              importValidationResult.preview.warning.length === 0
            ) {
              <p>
                Keine importierbaren Daten gefunden! Folgendes können Sie tun:
              </p>
              <ul>
                <li>Überprüfen Sie das Import-Format.</li>
                <li>Stimmt die Struktur mit der Vorlage überein?</li>
                <li>
                  Falls Sie mehrere Jahre importieren wollen, aktivieren Sie die
                  entsprechende Checkbox im Kopfbereich (vorher abbrechen).
                </li>
              </ul>
            } @else {
              <ul class="list-none icon-list">
                <li
                  *ngIf="
                    importValidationResult.preview.warning.length > 0 ||
                    importValidationResult.hints.hasEmptyCells
                  ">
                  <i class="fas fa-warning"></i>
                  <span
                    >Import trotz Warnungen möglich. Warnungen können
                    verschiedene Ursachen haben. Häufig erscheinen sie, wenn
                    bestehende Werte im System durch leere Zellen in Ihrer Datei
                    mit <i>„keine Angabe (k. A.)“</i> überschrieben werden.
                    <b
                      >Bitte prüfen Sie, ob dies gewünscht ist, bevor Sie den
                      Import abschließen.</b
                    ></span
                  >
                </li>
                <li *ngIf="importValidationResult.preview.success.length > 0">
                  <i class="fas fa-plus-circle"></i> Neue Daten werden dem
                  ausgewählten Jahr und dem in der Importdatei hinterlegten
                  Indikator hinzugefügt.
                </li>
                <li *ngIf="importValidationResult.preview.info.length > 0">
                  <i class="fas fa-save"></i> Daten, die anhand der getroffenen
                  Auswahl gefunden wurden, werden überschrieben.
                </li>
                <li *ngIf="importValidationResult.preview.lock.length > 0">
                  <i class="fas fa-lock"></i> Bei gesperrten Indikatoren stellen
                  Sie sicher, dass die Indikatoren zu denen Sie Daten
                  importieren wollen freigegeben sind.
                </li>
                <li *ngIf="importValidationResult.preview.secondary.length > 0">
                  <i class="fas fa-ban"></i> Bei nicht gefundenen Indikatoren
                  stellen Sie sicher, dass Name und Schlüssel korrekt sind und
                  die Indikatoren bereits im System angelegt wurden, und Sie die
                  nötige Berechtigung haben den Import durchzuführen.
                </li>
                <li>
                  <i class="fas fa-arrow-right"></i> Die neu importierten oder
                  aktualisierten Daten können Sie nach dem Import in der
                  Datenpflege einsehen und bearbeiten, indem Sie den
                  entsprechenden Indikator abrufen.
                </li>
              </ul>
            }

            <p-divider />

            <div class="flex gap-3 align-items-center">
              <p-button
                [rounded]="true"
                severity="secondary"
                icon="fas fa-times-circle"
                [outlined]="true"
                (onClick)="resetImportSection()"
                label="abbrechen"></p-button>
              <p-button
                class="ml-auto"
                [rounded]="true"
                [severity]="
                  importValidationResult.preview.error.length > 0
                    ? 'warning'
                    : 'primary'
                "
                icon="fas fa-circle-check"
                (onClick)="import()"
                label="importieren"></p-button>
            </div>
          </div>
        }
      } @else {
        <app-alert
          header="Fehlende Rechte für den Datenimport"
          [canToggle]="false">
          <p>
            Sie haben keine Berechtigung, Daten zu importieren. Bitte wenden Sie
            sich an den Administrator.
          </p>
        </app-alert>
      }

      @if (!globalStore.selectedLayer()) {
        <div class="px-3 py-1" appAlertStyle="warning">
          <p>Zu Ihrer Auswahl existiert aktuell kein Jahr.</p>
          <p>Fügen Sie <a>hier</a> ein Jahr hinzu.</p>
        </div>
      } @else if (
        geoDataStore.initialized() &&
        !globalStore.selectedGeoData() &&
        !importValidationResult
      ) {
        <app-alert
          severity="warning"
          [canToggle]="false"
          header="Keine Geodaten vorhanden">
          <p>
            In diesem Raum wurden bisher keine Geodaten hinterlegt. Falls Ihnen
            die Geodaten aktuell noch nicht vorliegen, können Sie dennoch
            starten, indem Sie zunächst Daten mit Bezug auf Teilräume hochladen.
          </p>
          <p>
            <b
              >Dabei werden Name und Schlüssel der Teilräume aus den Daten
              übernommen.</b
            >
          </p>
          <p>
            Für eine spätere automatische Verknüpfung müssen
            <b
              >Name und Schlüssel der Geodaten exakt mit diesen Angaben
              übereinstimmen.</b
            >
          </p>
        </app-alert>
      }
    </div>
    <div *ngIf="!importValidationResult" class="col-6">
      <app-header
        icon="fas fa-cloud-download"
        text="Export"
        sub="Laden Sie Daten als Excel-Datei herunter."></app-header>

      @if (canExport()) {
        @if (selectedType && multipleYears) {
          <div
            class="p-3 mb-3 flex gap-3 p-card surface-ground align-items-center">
            <app-data-layer-type-entry
              selectionMode="multiple"
              [showLabel]="false"
              [showControls]="false"
              [dataLayerType]="selectedType"></app-data-layer-type-entry>
          </div>
        }

        @if (selectedLayer) {
          <div class="p-fluid p-3 pt-0 p-card surface-ground">
            <div class="mt-0 grid">
              <app-form-field-wrapper [colSize]="0" label="Sortieren nach ...">
                <p-dropdown
                  *ngIf="typeSelectItems as types"
                  [options]="sortingOptions"
                  [(ngModel)]="exportSorting"
                  optionLabel="label"
                  optionValue="value">
                  <ng-template let-item pTemplate="selectedItem">
                    <div class="flex align-items-center gap-2">
                      <i [class]="item.icon"></i>
                      <span>{{ item.label }}</span>
                    </div>
                  </ng-template>
                  <ng-template let-item pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <i [class]="item.icon"></i>
                      <span>{{ item.label }}</span>
                    </div>
                  </ng-template>
                </p-dropdown>
              </app-form-field-wrapper>
              <app-form-field-wrapper [colSize]="0" label="Reihenfolge ...">
                <p-dropdown
                  [options]="orderOptions"
                  [(ngModel)]="exportOrder"
                  optionLabel="label"
                  optionValue="value">
                  <ng-template let-item pTemplate="selectedItem">
                    <div class="flex align-items-center gap-2">
                      <i [class]="item.icon"></i>
                      <span>{{ item.label }}</span>
                    </div>
                  </ng-template>
                  <ng-template let-item pTemplate="item">
                    <div class="flex align-items-center gap-2">
                      <div class="flex align-items-center gap-2">
                        <i [class]="item.icon"></i>
                        <span>{{ item.label }}</span>
                      </div>
                    </div>
                  </ng-template>
                </p-dropdown>
              </app-form-field-wrapper>
            </div>

            <p class="text-color-secondary text-xs -mt-1">
              Sortieren Sie die Datenliste vor dem Export nach Wunsch.
            </p>
          </div>

          @if (
            !multipleYears &&
            !indicatorDataStore.dataLayerHasData(selectedLayer._id)
          ) {
            <app-alert
              styleClass="py-2 px-3"
              severity="info"
              [canToggle]="false">
              <span class="flex align-items-baseline gap-2">
                <i class="fas fa-info-circle"></i> Im gewählten Jahr sind keine
                Daten vorhanden. Bitte überprüfen Sie Ihre Auswahl.
              </span>
            </app-alert>
          }

          <div class="p-3 pt-1" appAlertStyle="info">
            <h4 class="flex gap-2 align-items-center">
              Daten für ausgewählte Indikatoren exportieren
            </h4>
            <p>
              Exportiert die Datenliste nur für die von Ihnen gewählten
              Indikatoren.
            </p>
            <p-button
              [rounded]="true"
              icon="fas fa-list-check"
              (onClick)="activeExportSelection = true"
              label="auswählen"></p-button>
          </div>

          @if (multipleYears) {
          } @else if (indicatorDataStore.dataLayerHasData(selectedLayer._id)) {
            <div class="p-3 pt-1" appAlertStyle="info">
              <h4 class="flex gap-2 align-items-center">
                Daten für alle Indikatoren exportieren
              </h4>
              <p>
                Exportiert die Datenliste für sämtliche Indikatoren, unabhängig
                davon, ob sie Daten enthalten.
              </p>
              <p-button
                [rounded]="true"
                icon="fas fa-download"
                (onClick)="exportData(DataExportMode.IncludeEmpty)"
                label="exportieren"></p-button>
            </div>
            <div class="p-3 pt-1" appAlertStyle="info">
              <h4 class="flex gap-2 align-items-center">
                Daten nur für Indikatoren mit Daten exportieren
              </h4>
              <p>
                Exportiert die Datenliste nur mit den Indikatoren, die bereits
                Daten enthalten.
              </p>
              <p-button
                [rounded]="true"
                icon="fas fa-download"
                (onClick)="exportData(DataExportMode.ExcludeEmpty)"
                label="exportieren"></p-button>
            </div>
            <div class="p-3 pt-1" appAlertStyle="info">
              <p>Alle veröffentlichten Daten exportieren</p>
              @if (
                !indicatorDataStore.dataLayerHasPublishedData(selectedLayer._id)
              ) {
                <p>
                  <i class="fas fa-info-circle"></i> Das ausgewählte Jahr
                  enthält keine veröffentlichten Daten.
                </p>
              }

              <p-button
                [rounded]="true"
                [disabled]="
                  !indicatorDataStore.dataLayerHasPublishedData(
                    selectedLayer._id
                  )
                "
                icon="fas fa-earth-europe"
                (onClick)="exportData(DataExportMode.published)"
                label="veröffentlichte exportieren"></p-button>
            </div>
          }
        } @else {
          <app-alert
            styleClass="py-2 px-3"
            text="Es ist kein Jahr ausgewählt."></app-alert>
        }
      } @else {
        <app-alert
          header="Fehlende Rechte für den Datenexport"
          [canToggle]="false">
          <p>
            Sie haben keine Berechtigung, Daten zu exportieren. Bitte wenden Sie
            sich an den Administrator.
          </p>
        </app-alert>
      }
    </div>
  </div>
}

<p-sidebar
  (onHide)="closeOverview()"
  position="right"
  [modal]="false"
  [styleClass]="'w-6'"
  [visible]="dataToShowInOverview.length > 0">
  <ng-template pTemplate="header">
    <app-header icon="fas fa-circle-info" text="Übersicht"></app-header
  ></ng-template>
  <app-data-import-list
    *ngIf="dataToShowInOverview.length > 0"
    [validations]="importValidationResult"
    [icon]="icon"
    [items]="dataToShowInOverview"></app-data-import-list>
</p-sidebar>

<app-mask
  [visible]="dataToShowInOverview.length > 0"
  (click)="closeOverview()"></app-mask>

<p-sidebar
  (onHide)="closeExportSelection()"
  position="right"
  [modal]="false"
  [styleClass]="'w-11'"
  [visible]="activeExportSelection">
  <ng-template pTemplate="header">
    <app-header
      icon="fas fa-list-check"
      text="Daten auswählen und exportieren"
      sub="Sie wählen Indikatoren aus, für die die Daten exportiert werden."></app-header
  ></ng-template>

  @if (activeExportSelection) {
    <app-indicator-pick-list
      targetHeaderSubtitle="Für diese Indikatoren werden die zugehörigen Daten exportiert."></app-indicator-pick-list>
    <p-divider />
    <div class="flex gap-3 align-items-center">
      <p-button
        icon="fas fa-times-circle"
        rounded="true"
        text="true"
        severity="secondary"
        (onClick)="closeExportSelection()"
        label="abbrechen"></p-button>
      <p-button
        class="ml-auto"
        [rounded]="true"
        [disabled]="indicatorStore.selection().length === 0"
        icon="fas fa-file-excel"
        (onClick)="
          exportData(
            multipleYears
              ? DataExportMode.MultipleYears
              : DataExportMode.CustomIndicators
          )
        "
        label="Daten exportieren"></p-button>
    </div>
  }
</p-sidebar>
<app-mask
  [visible]="activeExportSelection"
  (click)="closeExportSelection()"></app-mask>
